import { render } from "./AssignContactPersonDialog.vue?vue&type=template&id=04cb1de7&scoped=true"
import script from "./AssignContactPersonDialog.vue?vue&type=script&lang=js"
export * from "./AssignContactPersonDialog.vue?vue&type=script&lang=js"

import "./AssignContactPersonDialog.vue?vue&type=style&index=0&id=04cb1de7&scoped=true&lang=css"

import exportComponent from "/home/Daten/Entwicklung/repositories/bdl_ui/de.stone.bdl.management.ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04cb1de7"]])

export default __exports__